import { formatLicenseLimit } from 'shared/utils/license';

const LicenseLimit = ({ limit }) => formatLicenseLimit(limit);

export default LicenseLimit;
